import { createContext, useContext } from 'react';

import { OverlayContextProps } from '../../overlay/types';

import { default_overlay_context } from './defaults';

export const OverlayContext = createContext<OverlayContextProps>(default_overlay_context);

export const useOverlayContext = () => useContext(OverlayContext) as OverlayContextProps;
